import { Capacitor } from '@capacitor/core';

/**
 * Returns true when running inside a Capacitor native shell (iOS / Android).
 * Returns false on the web browser.
 */
export const isNative = (): boolean => Capacitor.isNativePlatform();
